// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"3018c64d","408":"50e9991b","431":"8a7cfea3","453":"51d8bfbf","514":"6e29f9cf","760":"12eb873d","862":"66a03e5b","954":"3aaa16ad"}[chunkId] + ".chunk.js";
};